'use client';

import { DotLottieWorkerReact } from '@lottiefiles/dotlottie-react';

import { Styles, css } from '@flipster/styled-system/css';

import { contentfulImageUrl } from '@web/app/[locale]/(web)/campaign/_section/misc/assets';

const checkLottie = (url: string) => url.endsWith('.lottie');

interface ImageOrLottieProps {
  url?: string | null;
  alt?: string;
  css?: Styles;
}

// TODO features > content > assets 껄 쓰도록 변경 필요
export const ImgOrLottie = ({ url, alt, css: cssProps }: ImageOrLottieProps) => {
  const isLottie = url && checkLottie(url);

  if (!url) return null;

  if (isLottie) {
    return <DotLottieWorkerReact src={url} autoplay loop className={css(cssProps)} />;
  }

  return <img src={contentfulImageUrl(url)} alt={alt} className={css(cssProps)} />;
};
